import React, { FC, useState } from "react";
import { useSelector } from "react-redux";
import { Form } from "../../../models/formModel";
import { getPrototype } from "../../../selectors/protoTypeSelector";
import FormDisplayComponent from "./formDisplayComponent";
import "../prototypeComponent.scss"
import { BsArrowRight } from "react-icons/bs";

export interface FormRowComponentProps {
  formList: Form[];
  rowNumber: number;
  isReverse: boolean;
  isLeftDownArrow?: boolean;
}

const FormRowComponent: FC<FormRowComponentProps> = ({
  formList,
  rowNumber,
  isReverse,
  isLeftDownArrow = false,
}) => {
  const renderDisplayForms = () => {
    let renderFormList = [];
    let startIndex = (rowNumber*6) - 6;
    let endIndex = startIndex+6;
    for (let index = startIndex; index < endIndex; index++) {
      if (index < formList.length) {
        let form = {
          index: index,
          form: formList[index],
          isLast: index === endIndex-1 ? true : false,
          isReverse: isReverse,
          formListLength: formList.length,
        };
        renderFormList.push(form);
      }
    }
    
    return( 
      renderFormList.map((formRender) => {
      return (
        <FormDisplayComponent
          form={formRender.form}
          index={formRender.index}
          isLast={formRender.isLast}
          isReverse={formRender.isReverse}
          formListLength = {formRender.formListLength}
        />
      );
    })
    )
  };

  return (
    <>
      {!isReverse && (
        <>
          {/* {isLeftDownArrow && (
            <div className="row">
              <div className="col-1">
                <div className="arrow-down">Arrow Down</div>
              </div>
            </div>
          )} */}
        <div className="row prototype-create-main-row">

            {renderDisplayForms()}

        </div>

        </>
      )}
      {isReverse && (
        <>
          {/* <div className="row flex-row-reverse">
            <div className="col-1">
              <div className="arrow-down">Arrow Down</div>
            </div>
          </div> */}
          <div className="row prototype-create-main-row flex-row-reverse">
            {renderDisplayForms()}
          
          </div>
        </>
      )}
    </>
  );
};

export default FormRowComponent;
